package org.hs_soft.runmynesto.data.local_datasource.local_storage.options

import org.hs_soft.runmynesto.data.local_datasource.local_storage.saveToLocalStorage
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.operation.SaveLanguageRepository
import org.hs_soft.runmynesto.domain.util.IdUtils

class SaveLanguageRepositoryImpl:SaveLanguageRepository {

    override suspend fun saveLanguage(lang: String) {
        saveToLocalStorage(IdUtils.language,lang)
    }


}
